import { licenseGuard } from "../func"

const statisticsRouter = {
  path: "statistics",
  component: () => import("@/components/frame/main.vue"),
  children: [
    {
      path: "",
      name: "statistics",
      beforeEnter: licenseGuard,
      redirect: { name: "rate-summary" },
      component: () => import("@/components/statistics/index.vue"),
      children: [
        {
          path: "rate/summary",
          name: "rate-summary",
          meta: { auth: ["Manager"] },
          component: () => import("@/components/statistics/rate-summary.vue"),
          beforeEnter: licenseGuard,
        },
        {
          path: "rate/remote",
          name: "rate-remote",
          meta: { auth: ["Manager"] },
          component: () => import("@/components/statistics/rate-remote.vue"),
          beforeEnter: licenseGuard,
        },
        {
          path: "rate/warning",
          name: "rate-warning",
          meta: { auth: ["Manager"] },
          component: () => import("@/components/statistics/rate-warning.vue"),
          beforeEnter: licenseGuard,
        },
        {
          path: "log/remote",
          name: "log-remote",
          meta: { auth: ["Manager"] },
          component: () => import("@/components/statistics/log-remote.vue"),
          beforeEnter: licenseGuard,
        },
        {
          path: "log/warning",
          name: "log-warning",
          meta: { auth: ["Manager"] },
          component: () => import("@/components/statistics/log-warning.vue"),
          beforeEnter: licenseGuard,
        },
        {
          path: "log/access",
          name: "log-access",
          meta: { auth: ["Manager"] },
          component: () => import("@/components/statistics/log-access.vue"),
          beforeEnter: licenseGuard,
        },
        {
          path: "log/transfer",
          name: "log-transfer",
          meta: { auth: ["Manager"] },
          component: () => import("@/components/statistics/log-transfer.vue"),
          beforeEnter: licenseGuard,
        },
        {
          path: "log/delete",
          name: "log-delete",
          meta: { auth: ["Manager"] },
          component: () => import("@/components/statistics/log-delete.vue"),
          beforeEnter: licenseGuard,
        },
      ],
    },
  ],
}

export default statisticsRouter
